import * as theme from "../../theme";

export const SIDEBAR_WIDTH = 250;
export const SIDEBAR_COLLAPSED_WIDTH = 64;

export const MENU_FONT = (size = 15) => ({fontSize: size, fontFamily: "'Open Sans', sans-serif", fontWeight: 500, color: 'inherit'});

export const COLLAPSED_ITEM = {justifyContent: 'center', minWidth: 0, padding: '8px 0'};
export const EXPANDED_ITEM = {padding: '6px 12px'};
export const COLLAPSED_ICON = {minWidth: 0};
export const EXPANDED_ICON = {minWidth: 32};

export const MENU_TEXT_COLOR = '#647488';
export const MENU_ACTIVE_GREEN = '#3EAC4D';

export const ACTIVE_CLASS_STYLES = {
    backgroundColor: '#3EAC4D !important',
    borderRadius: 8,
    color: `${theme.white} !important`,
    '& .MuiListItemIcon-root': {color: theme.white},
    '& .MuiListItemText-primary': {color: `${theme.white} !important`, ...MENU_FONT()},
    '& img': {filter: 'brightness(0) invert(1)'},
};